import {connect} from 'react-redux';

import Documents from '-/components/connected/steps/Documents';
import Hero from '-/components/connected/steps/Hero';
import NotAccepting from '-/components/connected/steps/NotAccepting';
import ValidationInfo from '-/components/connected/steps/ValidationInfo';
import VerifyAccountCCR from '-/components/connected/steps/VerifyAccountCCR';
import FinalReview from '-/components/connected/steps/FinalReview';
import VerifyDob from '-/components/connected/steps/VerifyDob';
import VerifySSN from '-/components/connected/steps/VerifySSN';
import VerifyAccount from '-/components/connected/steps/VerifyAccount';
import VerifyAddress from '-/components/connected/steps/VerifyAddress';
import BuyerInfo from '-/components/connected/steps/BuyerInfo';
import VehicleInfo from '-/components/connected/steps/VehicleInfo';
import EmploymentInfo from '-/components/connected/steps/EmploymentInfo';
import AdditionalIncome from '-/components/connected/steps/AdditionalIncome';
import Congrats from '-/components/connected/steps/Congrats';
import AddCoApp from '-/components/connected/steps/AddCoApp';
import Callback from '-/components/connected/steps/Callback';
import FinalQuestions from '-/components/connected/steps/FinalQuestions';
import Submit from '-/components/connected/steps/Submit';
import StipsList from '-/components/connected/steps/StipsList';
import StipsStatus from '-/components/connected/steps/StipsStatus';
import StipsWelcome from '-/components/connected/steps/StipsWelcome';
import StipsResubmit from '-/components/connected/steps/StipsResubmit';
import StipsSubmitted from '-/components/connected/steps/StipsSubmitted';
import StipEdit from '-/components/connected/steps/StipEdit';
import NewOffer from '-/components/connected/steps/NewOffer';
import Pin from '-/components/connected/steps/Pin';
import Citizenship from '-/components/connected/steps/Citizenship';
import PriorMembership from '-/components/connected/steps/PriorMembership';
import Segment from '-/components/connected/steps/Segment';
import Reveal from '-/components/connected/steps/Reveal';

import {get} from '-/util/lodash';

const steps = {
    Hero,
    ValidationInfo,
    VerifyAccountCCR,
    FinalReview,
    VerifyDob,
    VerifySSN,
    VerifyAccount,
    VerifyAddress,
    BuyerInfo,
    VehicleInfo,
    EmploymentInfo,
    AdditionalIncome,
    Congrats,
    Documents,
    AddCoApp,
    Callback,
    FinalQuestions,
    NotAccepting,
    Submit,
    StipsList,
    StipsStatus,
    StipsWelcome,
    StipsResubmit,
    StipsSubmitted,
    StipEdit,
    NewOffer,
    Pin,
    Citizenship,
    PriorMembership,
    Reveal,
    Segment
};

const StepLookup = props => {
    const {step} = props;
    const StepComponent = steps[step];

    return StepComponent ? <StepComponent {...props} /> : null;
};

const mapStateToProps = state => {
    const documents = get(state, 'documents');
    const dealType = get(state, 'creditor.type', 'creditUnion');

    return {dealType, documents};
};

export default connect(mapStateToProps)(StepLookup);
